import { Pinia, Store } from 'pinia-class-component';
import { initClient } from '../../api';
import { TestEquipmentTimeUnitAPIControllerUIClient, TimeUnit } from '../../components/backend/backendapi';

@Store({
  id: 'TimeUnitStore',
  name: 'TimeUnitStore',
})
export default class TimeUnitStore extends Pinia {
  private readonly api = initClient(TestEquipmentTimeUnitAPIControllerUIClient);

  //data
  private _loadingPromise: Promise<TimeUnit[]> | null = null;
  private _timeUnits: TimeUnit[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get timeUnits(): TimeUnit[] {
    return this._timeUnits;
  }

  get timeUnitsById(): Map<number, TimeUnit> {
    return new Map(this._timeUnits.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._timeUnits.splice(0);
  }

  setTimeUnits(timeUnits: TimeUnit[]): void {
    this._timeUnits.splice(0);
    this._timeUnits.push(...timeUnits);
  }

  rememberTimeUnit(timeUnit: TimeUnit): void {
    const index = this._timeUnits.findIndex(e => e.id === timeUnit.id);
    if (index >= 0) {
      this._timeUnits.splice(index, 1, timeUnit);
    } else {
      this._timeUnits.push(timeUnit);
    }
  }

  forgetTimeUnit(timeUnit: TimeUnit): void {
    const index = this._timeUnits.findIndex(e => e.id === timeUnit.id);
    if (index >= 0) {
      this._timeUnits.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const timeUnits = await this._loadingPromise;
      this.setTimeUnits(timeUnits ?? []);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._timeUnits.length > 0) {
      return;
    }
    return await this.reload();
  }
}